var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-sim',{attrs:{"script-src":"/simulations/buffers-a/stemble-buffers-a.js","styles-src":"/simulations/buffers-a/styles.css"}},[_c('stemble-buffers-a',_vm._g(_vm._b({},'stemble-buffers-a',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }